import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
        //  backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    modalView: {
        flex: 1,
        flexDirection: 'row',
        paddingHorizontal: 12,
        //paddingVertical: 12,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        position: 'absolute',
        // bottom: Platform.select({
        //     android: 49,
        //     ios: 79,
        //     default: 79,
        // }),
    },
    modalText: {
        fontSize: 16,
        fontWeight: '500',
        lineHeight: 19,
        color: 'white',
        textAlign: 'left',
        marginLeft: 8,
    },
    closeButton: {
        backgroundColor: 'white',
        borderRadius: 5,
        paddingVertical: 10,
        paddingHorizontal: 20,
    },
    closeButtonText: {
        fontSize: 16,
        color: 'red',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    alignSelf: {
        alignSelf: 'center',
    },
    marginLeft: {
        marginLeft: 12,
    },
    marginRight: {
        marginLeft: 4,
    },
    marginHorizontal: {
        marginHorizontal: 6,
    },
    containerOnClose: {
        flex: 1,
        flexDirection: 'row',
        marginLeft: 12,
        alignItems: 'center',
    },
    dividerVertical: {
        height: 62,
        borderWidth: 0.5,
        marginHorizontal: 12,
    },
})
export default styles
